import axios from "axios";
import { configureCountryData } from "../helpers/index";

const url =
  "https://restcountries.com/v3.1/all?fields=name,altSpellings,area,borders,capital,cca2,continents,flags,landlocked,region,population";

const databaseURL = "https://dpocsai-geogames.herokuapp.com/users";

export const getCountryData = async () => {
  try {
    const { data } = await axios.get(url);
    return configureCountryData(data);
  } catch (error) {
    console.log(error.message);
  }
};

export const getValidCountryNames = async () => {
  try {
    const { data } = await axios.get(url);
    return configureCountryData(data);
  } catch (error) {
    console.log(error.message);
  }
};

export const getUser = (id) => axios.get(`${databaseURL}/${id}`);

export const createUser = (newUser) => {
  return axios.post(`${databaseURL}/new`, newUser);
};

export const updateUser = (id, updatedUser) =>
  axios.patch(`${databaseURL}/${id}`, updatedUser);
